

























































































































































import Component, { mixins } from "vue-class-component";
import ErrorMixin from "@/mixins/errorMixins";

@Component
export default class AutoBackup extends mixins(ErrorMixin) {
  public active = false;
  public hours = new Array();
  public days = [1, 3, 5, 10, 20, 30, 40];
  public autobackUpConfig = {
    autoDeleteJours: 0,
    autoDeleteMode: "ACTIVE",
    chemin: "backup",
    heure: 0,
    jours: [false, false, false, false, false, false, false],
    methode: "DESACTIVED",
  };

  public mounted() {
    this.$store.dispatch("bdd/isAutobackupActive").then((response: any) => {
      console.log(response);
      this.active = response.data;
      if (response.data) {
        this.$store
          .dispatch("bdd/getAutobackupConfig")
          .then((autobackupData: any) => {
            console.log(autobackupData.data);
            this.autobackUpConfig = autobackupData.data;
          });
      }
    });
    for (let index = 0; index < 24; index++) {
      this.hours.push({ value: index, text: index + ":00" });
    }
  }

  public getLabel(isActive: boolean) {
    return isActive
      ? this.$t("Active").toString()
      : this.$t("Inactive").toString();
  }

  public activateDay(index: number) {
    this.autobackUpConfig.jours[index] = !this.autobackUpConfig.jours[index];
    this.$forceUpdate();
  }

  public selectAll() {
    this.autobackUpConfig.jours = [true, true, true, true, true, true, true];
  }

  public cancel() {
    this.$emit("hideAutobackUp");
  }

  public save() {
    if (this.autobackUpConfig.chemin === "") {
      this.autobackUpConfig.chemin = "backup";
    }
    this.$store.dispatch("login/setLoading", true);
    this.$store
      .dispatch("bdd/saveAutobackupConfig", this.autobackUpConfig)
      .then(
        (data: any) => {
          this.setSuccess(this.$t("SuccessMod").toString());
          this.$store.dispatch("login/setLoading", false);
          this.cancel();
        },
        (error: any) => {
          this.setErrorFromTxt(error.toString());
          this.$store.dispatch("login/setLoading", false);
        }
      );
  }
}
